(function ($) {
  Drupal.behaviors.bundleFlowv1 = {
    attach: function (context, settings) {
      var $modules = $('.js-bundle-flow', context);

      $modules.each(function (i, obj) {
        var $flow = $(obj);

        // containing template can turn this off if they are taking care of
        // the bundle flow init
        if ($flow.closest('[data-disable-bundle-flow-attach="1"]').length > 0) {
          return;
        }

        // BundleFlowState/BundleFlowDirector are in js/shared/bundle_flow.js
        var bundle_state = new site.bundleflow.BundleFlowState($flow);
        var bundleflow = new site.bundleflow.BundleFlowDirector($flow, bundle_state);
      });
    }
  };
})(jQuery);
